import { v4 as uuidv4 } from "uuid";
import {
  CLIENT_NUTRITION_DEFAULT_PURPOSE,
  CLIENT_NUTRITION_STATUS_ACTIVE,
} from "../../Firestore/nutrition/nutritionPaths";

export function createNutritionPlanGoalsSeed() {
  return {
    macro_input_mode: "percent",
    nutrients: [],
    percentages: [],
  };
}

export function createCoachNutritionPlanSeed(id = uuidv4()) {
  return {
    id,
    name: "",
    notes: "",
    version: 1,
    goals: createNutritionPlanGoalsSeed(),
    meals: [],
  };
}

export function createClientNutritionPlanSeed() {
  return {
    name: "",
    notes: "",
    status: CLIENT_NUTRITION_STATUS_ACTIVE,
    purpose: CLIENT_NUTRITION_DEFAULT_PURPOSE,
    origin_type: "client_direct",
    goals: createNutritionPlanGoalsSeed(),
    meals: [],
  };
}
